import { useEffect, useState } from "react";

const useDebounced = (value, delay = 300) => {
  const [debounced, setDebounced] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};

export default useDebounced;